module.exports = __webpack_public_path__ + "img/rku10-4.287f2274.png";